import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar__body" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar__skeleton"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "modal-order-action" }

import { IAccountingInfo } from '@/@types/api/accounting';
import { IMeterInfo } from '@/@types/api/meters';
import { IAppSetting } from '@/@types/config';

import { ref, computed, watch, inject } from 'vue';

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useAccounting } from '@/composables/accounting';
import { useI18n } from 'vue-i18n';
import { useConfig } from '@/composables/config';

import SmPaymentCard from '@/components/common/SmPaymentCard/SmPaymentCard.vue';
import SmMetersCard from '@/components/common/SmMetersCard/SmMetersCard.vue';
import SmRequestsCard from '@/components/common/SmRequestsCard/SmRequestsCard.vue';
import SmAlert from '@/components/ui/SmAlert/SmAlert.vue';
import SmModal from '@/components/ui/SmModal/SmModal.vue';
import SmButton from '@/components/ui/buttons/SmButton/SmButton.vue';

import '@/layouts/SmSidebar/style.scss';

// Global methods


export default /*#__PURE__*/_defineComponent({
  __name: 'SmSidebar',
  setup(__props) {

const store = useStore();
const router = useRouter();
const $accounting = useAccounting();
const { t } = useI18n();
const { getAppSettings } = useConfig();
const notifications: any = inject('notifications-plugin');

// Data

const totalCost = ref<number>(0);
const comission = ref<number>(0);
const isLoading = ref<boolean>(false);
const showVerificationModal = ref<boolean>(false);
const isLoadingVerification = ref<boolean>(false);
const meterItem = ref<IMeterInfo>();
const appSettings: IAppSetting = getAppSettings();
const isLegalAccount = appSettings?.allowedAccountTypes === 1


// Computed

const canPayForAllAccounts = computed((): boolean => {
  const menuAppNames = appSettings?.menu.map(item => item.name_app);

  const canPay = store.state.accounting.info?.CanPayForAllAccounts;
  // const shouldShowButton = appSettings.showButtonPayAll;
  
  // return canPay && shouldShowButton;

  return menuAppNames.includes('Оплата ЖКУ') && canPay;
});

const isShowCreateRequests = computed(() =>
  appSettings?.menu.some(app => app.name_app === "Заявки" && app.visible === 1));

const accounts = computed(
  (): IAccountingInfo[] => store.state.accounting.info?.Data || [],
);

const filteredAccounts = computed(() => {
  const activeAccounts = accounts.value.filter((account) => !account.IsClosed);

  return activeAccounts;
});


const pendingMeters = computed(
  (): IMeterInfo[] => store.getters['meters/getPendingMeters'] || [],
);

const expiredVerificationMeters = computed(
  (): IMeterInfo[] =>
    store.getters['meters/getExpiredVerificationMeters'] || [],
);

// [START] Methods
const getExpiredVerificationIdentText = (meter: IMeterInfo) => isLegalAccount ? `№${meter.Ident}` : t('ident', [meter.Ident]);

const getNonNegativeNumber = (num: number) => {
  return num < 0 ? 0 : num;
};

const getTotalCost = () => {
  const { useSeparatedFinePayment } = appSettings;
  const accounts = filteredAccounts.value;
  let sum = 0;
  let sumFine = 0;

  for (let i = 0; i < accounts.length; i++) {
    const { SumFine, Sum } = accounts[i];

    sumFine += getNonNegativeNumber(SumFine);

    if (useSeparatedFinePayment && SumFine !== 0) {
      const currentSumFine = getNonNegativeNumber(SumFine);
      const currentSum = getNonNegativeNumber(Sum);

      sum += parseFloat((currentSum - currentSumFine).toFixed(2));
    } else sum += getNonNegativeNumber(Sum);
  }

  const requestSum = useSeparatedFinePayment ? sum + sumFine : sum;

  $accounting.fetchSumWithComission(requestSum).then((result) => {
    totalCost.value = getNonNegativeNumber(result.TotalSum);
    comission.value = getNonNegativeNumber(result.Comission);
  });
};

const fetchAccountingInfo = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('accounting/fetchInfo');
  } catch (error) {
    throw Error(`Ошибка получения списка лицевых счетов: ${error}`);
  } finally {
    isLoading.value = false;
  }
}

const handleShowVerificationModal = (item: IMeterInfo): void => {
  meterItem.value = item;
  showVerificationModal.value = true;
};

const handleHideVerificationModal = () => {
  showVerificationModal.value = false;
}

const handleVerification = async () => {
  isLoadingVerification.value = true;

  try {
  
    const { isSucceed, error, id } = await store.dispatch("meters/createRequestOnMeterRecheck", meterItem.value?.ID);

    if (isSucceed) {
      router.push({
        name: 'RequestDetail',
        params: { id }
      })

      return;
    }

    notifications
      .createPush({
        type: 'error',
        message: error,
        duration: 3000,
      });
  } catch (error) {
    throw Error(`Ошибка создания заявки: ${error}`);
  } finally {
    isLoadingVerification.value = false;
    showVerificationModal.value = false;
  }
};

const initPage = async () => {
  fetchAccountingInfo();
  getTotalCost();
}
// [END] Methods

// Watchers
watch(
  () => accounts,
  (): void => {
    getTotalCost();
  },
  { deep: true }
)

// Created
initPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (accounts.value.length)
              ? (_openBlock(), _createBlock(SmPaymentCard, {
                  key: 0,
                  cost: totalCost.value,
                  comission: comission.value,
                  count: filteredAccounts.value.length,
                  "can-pay-for-all-accounts": canPayForAllAccounts.value
                }, null, 8, ["cost", "comission", "count", "can-pay-for-all-accounts"]))
              : _createCommentVNode("", true),
            (pendingMeters.value.length)
              ? (_openBlock(), _createBlock(SmMetersCard, {
                  key: 1,
                  count: pendingMeters.value.length
                }, null, 8, ["count"]))
              : _createCommentVNode("", true),
            (accounts.value.length && isShowCreateRequests.value)
              ? (_openBlock(), _createBlock(SmRequestsCard, { key: 2 }))
              : _createCommentVNode("", true),
            (expiredVerificationMeters.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(expiredVerificationMeters.value, (item, i) => {
                  return (_openBlock(), _createBlock(SmAlert, {
                    key: `expired-meter-${i}`,
                    title: _unref(t)('title'),
                    type: "info",
                    "footer-button-text": _unref(t)('buttons.confirm'),
                    onFooterClick: ($event: any) => (handleShowVerificationModal(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('message', [item.Resource, item.Address])) + " ", 1),
                      _hoisted_4,
                      _hoisted_5,
                      _createTextVNode(" " + _toDisplayString(getExpiredVerificationIdentText(item)) + " ", 1),
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(_unref(t)('meter_number', [item.FactoryNumber])), 1)
                    ]),
                    _: 2
                  }, 1032, ["title", "footer-button-text", "onFooterClick"]))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(SmModal, {
              class: "modal-order",
              modelValue: showVerificationModal.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showVerificationModal).value = $event)),
              title: _unref(t)('title_modal')
            }, {
              body: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_unref(t)('message', [meterItem.value?.Resource, meterItem.value?.Address])) + " ", 1),
                  _hoisted_7,
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('verification_info')), 1)
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(SmButton, {
                    type: "error",
                    class: "modal-order-action__button button-cancel",
                    loading: isLoadingVerification.value,
                    onClick: handleHideVerificationModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.cancel')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(SmButton, {
                    type: "primary",
                    class: "modal-order-action__button",
                    loading: isLoadingVerification.value,
                    onClick: handleVerification
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.confirm')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ], 64))
    ])
  ]))
}
}

})